import { useState } from "react";
import { useLocation } from "react-router";
import { CircleHelp } from "lucide-react";
import { cn } from "@/lib/cn";
import { ajudaDaRota } from "@/lib/ajuda/rotas";
import { useIsMobile } from "@/lib/use-media-query";
import { ALTURA_DA_BARRA } from "@/components/layout/mobile/BarraDeAbas";
import { PainelDeAjuda } from "./PainelDeAjuda";
import { useAlturaDoRodape } from "./RodapeOcupado";
import { useSomeAoRolar } from "./use-some-ao-rolar";

/**
 * "? Ajuda" fixo no canto de baixo — sempre à mão, sem rolar. No celular fica acima da barra de
 * abas; barra fixa de salvar/seleção empurra ele pra cima (RodapeOcupado). Some quando a rota não
 * tem ajuda (placeholder, legado). No celular é só o ícone e some enquanto a página desce.
 */
export function BotaoDeAjuda() {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const alturaOcupada = useAlturaDoRodape();
  const [aberto, setAberto] = useState(false);
  const escondido = useSomeAoRolar(isMobile);
  const ajuda = ajudaDaRota(pathname);
  if (!ajuda) return null;
  const base = isMobile ? `${ALTURA_DA_BARRA} + env(safe-area-inset-bottom) + 0.75rem` : "1rem";
  return (
    <>
      <button
        type="button"
        onClick={() => setAberto(true)}
        aria-label="Como funciona esta página"
        data-ajuda-da-pagina
        data-tour="botao-ajuda"
        style={{ bottom: `calc(${base} + ${alturaOcupada}px)` }}
        className={cn(
          "fixed right-4 z-30 inline-flex items-center justify-center gap-1.5 rounded-full border border-zinc-200 bg-white text-[13px] font-medium text-zinc-600 shadow-md transition-[color,background-color,transform,opacity] duration-200 hover:bg-zinc-50 hover:text-zinc-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300 dark:border-border dark:bg-card dark:text-muted-foreground dark:hover:text-foreground",
          isMobile ? "h-10 w-10" : "h-9 pl-2.5 pr-3.5",
          escondido && "pointer-events-none translate-y-4 opacity-0",
        )}
      >
        <CircleHelp className={isMobile ? "h-5 w-5" : "h-4 w-4"} />
        {!isMobile && "Ajuda"}
      </button>
      <PainelDeAjuda ajuda={ajuda} aberto={aberto} onAbertoChange={setAberto} />
    </>
  );
}
